module.exports = __webpack_public_path__ + "static/media/jean-grey-icon.4ca9adf0.png";